<template>
  <store-modal
      name="SubscriptionsAddressesWithdrawal"
      class="subscription-address-withdrawal-modal"
      :loading="withdrawalCreating"
      @closeModal="handleCancelCreate"
  >
    <template v-if="!_withdrawalStatus" #header>
      <div class="modal-header">
        <div class="title">
          {{ title }}
        </div>
      </div>
    </template>
    <template #body>
<!--      блок в случае если вывод уже запущен-->
      <div
        v-if="withdrawalCreated"
        class="body-padding-wrapper"
      >
        <div class="complete-info">
          <template v-if="_withdrawalStatus === 'init'">
            <div class="complete-info__title">{{ $t('subscriptions-addresses.modals.success.withdraw.title') }}</div>
            <div class="complete-info__row">
              <div class="label"> ID: </div>
              <div class="value"> {{ _withdrawalId }} </div>
            </div>
          </template>
          <template v-else-if="_withdrawalStatus === 'error'">
            <svg class="complete__img" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_9885_67665)">
                <rect width="60" height="60" rx="10" fill="#B24D4D"/>
                <path d="M24.8098 18.2197C24.9504 18.079 25.1412 18 25.3401 18H34.6599C34.8588 18 35.0496 18.079 35.1902 18.2197L41.7803 24.8098C41.921 24.9504 42 25.1412 42 25.3401V34.6599C42 34.8588 41.921 35.0496 41.7803 35.1902L35.1902 41.7803C35.0496 41.921 34.8588 42 34.6599 42H25.3401C25.1412 42 24.9504 41.921 24.8098 41.7803L18.2197 35.1902C18.079 35.0496 18 34.8588 18 34.6599V25.3401C18 25.1412 18.079 24.9504 18.2197 24.8098L24.8098 18.2197ZM25.6508 19.5L19.5 25.6508V34.3492L25.6508 40.5H34.3492L40.5 34.3492V25.6508L34.3492 19.5H25.6508Z" fill="white"/>
                <path d="M24.9697 24.9697C25.2626 24.6768 25.7374 24.6768 26.0303 24.9697L30 28.9393L33.9697 24.9697C34.2626 24.6768 34.7374 24.6768 35.0303 24.9697C35.3232 25.2626 35.3232 25.7374 35.0303 26.0303L31.0607 30L35.0303 33.9697C35.3232 34.2626 35.3232 34.7374 35.0303 35.0303C34.7374 35.3232 34.2626 35.3232 33.9697 35.0303L30 31.0607L26.0303 35.0303C25.7374 35.3232 25.2626 35.3232 24.9697 35.0303C24.6768 34.7374 24.6768 34.2626 24.9697 33.9697L28.9393 30L24.9697 26.0303C24.6768 25.7374 24.6768 25.2626 24.9697 24.9697Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_9885_67665">
                  <rect width="60" height="60" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <div class="complete-info__title">{{ $t('subscriptions-addresses.modals.error.withdraw.title') }}</div>
            <div v-if="_withdrawalTraceId" class="complete-info__row">
              <div class="label"> {{ $t('subscriptions-addresses.modals.error.withdraw.subtitle-with-request-id') }} </div>
              <div class="value"> {{ _withdrawalTraceId | preparedString(4) }} <copy :value="_withdrawalTraceId" /> </div>
            </div>
          </template>
          <template v-else-if="_withdrawalStatus === 'pending'">
            <div class="complete-info__title">{{ $t('subscriptions-addresses.modals.success.withdraw.title') }}</div>
          </template>
          <template v-else-if="_withdrawalStatus === 'processed'">
            <div class="complete__img">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_9739_70606)">
                  <rect width="60" height="60" rx="10" fill="#5CA450"/>
                  <path d="M36.3105 23.5605C36.9329 22.9382 37.942 22.9382 38.5644 23.5605C39.1791 24.1753 39.1867 25.1674 38.587 25.7914L30.1036 36.3957C30.0913 36.411 30.0782 36.4256 30.0644 36.4395C29.442 37.0619 28.4329 37.0619 27.8105 36.4395L22.1868 30.8158C21.5644 30.1934 21.5644 29.1842 22.1868 28.5618C22.8092 27.9395 23.8183 27.9395 24.4407 28.5618L28.8894 33.0106L36.2682 23.6082C36.2813 23.5915 36.2954 23.5756 36.3105 23.5605Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_9739_70606">
                    <rect width="60" height="60" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="complete-info__title">
              {{ $t('subscriptions-addresses.modals.success.withdraw.title') }}
            </div>
            <div class="complete-info__row">
              <div class="label">
                {{ $t('business-wallet.transaction_hash') }}
              </div>
              <div v-if="withdrawalHash || transactionHash" class="value">
                {{ (transactionHash || withdrawalHash) | preparedString(4) }}
                <copy class="complete__hash-copy" :value="transactionHash || withdrawalHash" />
              </div>
            </div>
          </template>
          <template v-else-if="_withdrawalStatus === 'rejected'">
            <div class="complete__title">{{ $t('subscriptions-addresses.modals.reject.withdraw.title') }}</div>
            <div class="complete-info__row">
              <div class="label"> {{ $t('subscriptions-addresses.modals.reject.withdraw.subtitle') }} </div>
              <div class="value"> {{ accountBalance }} </div>
            </div>
          </template>
        </div>
      </div>

      <!--      блок в случае если вывод еще запущен-->

      <div
        v-else
        class="body-padding-wrapper"
      >
        <business-wallet-network-select
          v-model="addressModel"
          :list="addressesList"
          :label="$t('create-withdrawal-request-modal.output_address')"
          :placeholer="select_address"
          uniq-key="id"
        />

        <!--            если выбран адрес, то показываем эти блоки-->
        <template v-if="addressModel">
          <div class="select-address-to">
            <base-input
              v-model.trim="addressTo"
              :status="(addressTo && !addressToValid) || depositWithdrawalAddressesMatch ? 'error' : ''"
              :placeholder="enter_address"
              :label="$t('create-withdrawal-request-modal.receiving_address')"
              allow-number-separation
            />
            <div class="address-book">
              <address-book-select
                v-model="value"
                :list="filteredAddressesList"
                with-search
                @input="handleSelectAddress"
              />
            </div>
          </div>
          <p v-if="depositWithdrawalAddressesMatch" class="create-withdrawal-request-modal__title-special">
            {{ $t('create-withdrawal-request-modal.deposit_withdrawal_addresses_match') }}
          </p>
          <p v-if="(addressTo && !addressToValid)" class=" create-withdrawal-request-modal__title-special">
            {{ $t('create-withdrawal-request-modal.invalid_address') }}
          </p>

          <template v-if="hasTag">
            <div>
              <base-input
                v-model.trim="tag"
                :error="!!tag && !tagValid ? $t('create-withdrawal-request-modal.wrong_tag') : ''"
                :placeholder="enter_tag"
                :label="$t('create-withdrawal-request-modal.tag')"
                error-position-bottom
              />
            </div>
          </template>

          <base-max-input
            v-model="amount"
            class="amount-max-input"
            placeholder="0"
            :label="$t('business-wallet.amount')"
            :min="minWithdrawal"
            :max="balanceAmount"
            has-action-btn
            @input="getFeeForTransferInput"
            @action-btn-click="setMaxAmount"
          >
            <template #label-left>
              <span class="amount-max-input__label">{{ $t('business-wallet.amount') }}</span>
            </template>
            <template #bottom-label>
              <div class="amount-max-input__bottom-label">
                <span class="label">min</span> <span class="value"> {{ minWithdrawal }} {{ balanceCurrencyId | getCurrencyTicker }}, </span>  <span class="label">max</span>  <span class="value">{{ balanceAmount | separatePeriods }} {{ balanceCurrencyId | getCurrencyTicker }}</span>
              </div>
            </template>
          </base-max-input>


          <div>
            <base-textarea
              v-model="description"
              :placeholder="$t('address_book.add_modal_placeholder')"
              :label="$t('address_book.add_modal_comment')"
              :max-length="255"
              size="large"
              resize="none"
            />
          </div>
          <div v-if="showCommission" class="commission-block">
            <spinner
              v-if="!_feeComplete"
              class="preloader"
            />
            <div
              v-else
              class="info-container"
              :class="{ 'disabled': feeAvailableSeconds < 0 }"
            >
              <div class="info-container__row">
                <div class="first-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.advance_balance') }}
                  </div>
                  <div class="value">
                      <span
                          :class="{danger: !balanceValid}">{{
                          accountBalance
                        }} {{ accountCurrencyId | getCurrencyTicker }}
                      </span>
                  </div>
                </div>
              </div>
              <div class="info-container__row">
                <div class="first-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.service-commission-amount') }}
                  </div>
                  <div class="value">
                    {{ tariffFee }} {{ accountCurrencyId | getCurrencyTicker }}
                  </div>
                </div>
                <div class="second-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.commission-source') }}
                  </div>
                  <div class="value">
                    {{ $t('payout-modal-transfer.advance_balance') }}
                  </div>
                </div>
              </div>
              <div class="info-container__row">
                <div class="first-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.blockchain-commission-amount') }}
                  </div>
                  <div class="value">
                    {{ networkFeeUSD }} {{ accountCurrencyId | getCurrencyTicker }}
                  </div>
                </div>
                <div class="second-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.commission-source') }}
                  </div>
                  <div class="value">
                    {{ feeSourceTitle }}
                  </div>
                </div>
              </div>
              <div class="info-container__row">
                <div class="first-line">
                  <div class="label">
                    <b> {{ $t('payout-modal-transfer.receive') }} </b>
                  </div>
                  <div class="value">
                    <b> {{ amountToReceive | separatePeriods }}
                      {{ balanceCurrencyId | getCurrencyTicker }} </b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>

    <template #footer>
      <template v-if="!withdrawalCreated">
        <div
          v-if="feeAvailableSeconds !== -1"
          class="create-withdrawal-request-modal__btn"
        >
          <base-button
            type="primary"
            :disabled="actionButtonDisabled"
            :label="actionButtonTitle"
            @click="createWithdrawal"
          />
        </div>
        <div
          v-else
          class="create-withdrawal-request-modal__btn"
        >
          <base-button
            type="secondary"
            :label="$t('create-withdrawal-request-modal.update')"
            @click="fetchFee"
          >
            <template #prepend>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.2638 7.74892C1.2638 11.5139 3.94057 14.0792 6.94724 14.6098C7.02903 14.6242 7.10722 14.655 7.17736 14.7002C7.2475 14.7455 7.3082 14.8044 7.35601 14.8736C7.40382 14.9428 7.4378 15.021 7.456 15.1035C7.4742 15.1861 7.47627 15.2716 7.4621 15.355C7.44792 15.4384 7.41778 15.5181 7.37338 15.5897C7.32899 15.6612 7.27121 15.7231 7.20336 15.7718C7.1355 15.8206 7.05889 15.8552 6.9779 15.8738C6.89692 15.8924 6.81314 15.8945 6.73135 15.88C3.20073 15.2566 0 12.2214 0 7.74892C0 5.84787 0.847786 4.35374 1.83748 3.21831C2.547 2.40445 3.3584 1.74273 4.01092 1.23686H2.02668C1.86585 1.23686 1.7116 1.1717 1.59787 1.05572C1.48415 0.939747 1.42025 0.782447 1.42025 0.618429C1.42025 0.454412 1.48415 0.297112 1.59787 0.181134C1.7116 0.0651559 1.86585 0 2.02668 0H5.66525C5.82609 0 5.98033 0.0651559 6.09406 0.181134C6.20779 0.297112 6.27168 0.454412 6.27168 0.618429V4.329C6.27168 4.49302 6.20779 4.65032 6.09406 4.7663C5.98033 4.88228 5.82609 4.94743 5.66525 4.94743C5.50442 4.94743 5.35017 4.88228 5.23644 4.7663C5.12271 4.65032 5.05882 4.49302 5.05882 4.329V2.04576L5.05761 2.04824C4.36386 2.58009 3.51728 3.23191 2.7835 4.07421C1.91631 5.06865 1.2638 6.27211 1.2638 7.74892ZM14.7362 8.25108C14.7362 4.52566 12.1164 1.9765 9.14857 1.40754C9.06586 1.39323 8.98676 1.36226 8.9159 1.31645C8.84505 1.27063 8.78385 1.21088 8.73587 1.14069C8.6879 1.07049 8.65411 0.991258 8.63649 0.907606C8.61886 0.823955 8.61774 0.737561 8.63321 0.653466C8.64867 0.56937 8.6804 0.489257 8.72654 0.417799C8.77269 0.346342 8.83232 0.284971 8.90198 0.237268C8.97163 0.189565 9.0499 0.156484 9.13222 0.139956C9.21454 0.123428 9.29926 0.123784 9.38144 0.141002C12.8672 0.808905 16 3.82684 16 8.25108C16 10.1521 15.1522 11.645 14.1625 12.7817C13.453 13.5955 12.6416 14.2573 11.9891 14.7631H13.9733C14.1342 14.7631 14.2884 14.8283 14.4021 14.9443C14.5159 15.0603 14.5797 15.2176 14.5797 15.3816C14.5797 15.5456 14.5159 15.7029 14.4021 15.8189C14.2884 15.9348 14.1342 16 13.9733 16H10.3347C10.1739 16 10.0197 15.9348 9.90594 15.8189C9.79221 15.7029 9.72832 15.5456 9.72832 15.3816V11.671C9.72832 11.507 9.79221 11.3497 9.90594 11.2337C10.0197 11.1177 10.1739 11.0526 10.3347 11.0526C10.4956 11.0526 10.6498 11.1177 10.7636 11.2337C10.8773 11.3497 10.9412 11.507 10.9412 11.671V13.953H10.9436C11.6361 13.4187 12.4839 12.7681 13.2165 11.9246C14.0837 10.9314 14.7362 9.72913 14.7362 8.25108Z" fill="#6750A4"/>
              </svg>
            </template>
          </base-button>
        </div>
      </template>
      <template v-else>
        <base-button
          type="primary"
          :label="$t('create-withdrawal-request-modal.close')"
          @click="handleCancelCreate"
        />
      </template>
    </template>
  </store-modal>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';

import AtSelect from 'at-ui/src/components/select';
import AtOption from 'at-ui/src/components/option';
import AtModal from 'at-ui/src/components/modal';
import CurrencyImg from "/public/components/elements/CurrencyImg";
import AtInput from 'at-ui/src/components/input';
import AtRadioGroup from 'at-ui/src/components/radio-group';
import AtRadio from 'at-ui/src/components/radio';
import LoadingSpinner from "/public/components/elements/LoadingSpinner";
import AtButton from 'at-ui/src/components/button';
import WithdrawalAddress from "../requests/components/WithdrawalAddress";
import AtAlert from 'at-ui/src/components/alert';
import BaseModal from "../BaseModal";
import CopyString from "/public/components/elements/CopyString";
import moment from "moment";
import bchaddr from 'bchaddrjs';

import {getCurrencyTicker, getNetworkName, getNetworkSystemName, preparedString} from '/public/filters';
import BigNumber from "bignumber.js";
import {FEE_TOKEN_SOURCE} from "../../../../common/constants/fee-token-source";
import _ from "lodash";
import BaseInput from "@/public/components/common/uiKit/input/base/index.vue";

import AddressBookSelect from "@/public/components/elements/business-walet/addressBookSelect/addressBookSelect.vue";
import Copy from "@/public/components/common/copy.vue";
import BaseTextarea from "@/public/components/common/uiKit/textarea/index.vue";
import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";
import cloneDeep from "lodash/cloneDeep";

export default {
    name: 'SubscriptionsAddressesWithdrawal',
    components: {
      BaseButton,
      BaseTextarea,
      Copy,
      AddressBookSelect,
      BaseInput,
        BaseModal,
        AtSelect,
        AtOption,
        AtModal,
        CurrencyImg,
        AtInput,
        AtRadioGroup,
        AtRadio,
        LoadingSpinner,
        AtButton,
        WithdrawalAddress,
        AtAlert,
        CopyString,

        BusinessWalletNetworkSelect: () => import(/* webpackChunkName: "public/components/elements/business-walet/Select/businessWalletNetworkSelect.vue" */ '/public/components/elements/business-walet/Select/businessWalletNetworkSelect.vue'),
        BaseMaxInput: () => import(/* webpackChunkName: "/public/components/elements/advance-balances/input" */ '/public/components/elements/advance-balances/input'),
        PopUp: () => import(/* webpackChunkName: "public/components/common/uiKit/popup" */ '/public/components/common/uiKit/popup'),
        Spinner: () => import (/* webpackChunkName: "Spinner" */ "/public/components/common/uiKit/spinner/index.vue"),
        StoreModal: () => import(/* webpackChunkName: "public/components/modals/StoreModal" */ '/public/components/modals/StoreModal'),
        Toggler:  () => import(/* webpackChunkName: "public/components/common/uiKit/toggler" */ '/public/components/common/uiKit/toggler'),
    },
    props: {
        addresses: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            accountId: '',
            addressId: '',
            networkId: '',
            value: '',
            temporaryValue: {},
            addressTo: '',
            tag: '',
            amount: '',
            isDebouncing: null,
            time: new Date().toJSON(),
            timerId: 0,
            description: '',
            addressBookId: '',
            transactionHash: '',
            currentModal: 'CreateWithdrawalRequestModal',

            feeSourceIsSender: false
        };
    },
    watch: {
      addressTo(v) {
        if (v !== this.temporaryValue.address) {
          this.value = {}
        } else {
          this.value = cloneDeep(this.temporaryValue)
        }
      },
      withdrawal: {
        deep: true,
        handler (val) {
          this.transactionHash = val.tx
        }
      },
      _withdrawalTx(val) {
        this.transactionHash = val
      },
      withdrawalCreated(n, o) {
        if (!(typeof n !== "undefined" && typeof o !== "undefined")) {
          return;
        }

        if (n === o) {
          return;
        }

        if (!n) {
          return;
        }

        this.refreshRequests({
          route: this.$route,
          router: this.$router,
        });
      },
      isOpen(opened) {
        if (!opened) {
          this.clearAllData();
          this.stopTimer();

          return;
        }

        this.startTimer();

        if (this.accounts.length) {
          this.accountId = this.accounts[0].accountId;
        }
        this.$nextTick(() => {
          if (this.addressWithdrawal) {
            this.addressId = this.addressWithdrawal;
          }
        });

        this.networkAddressBook();
      },
      accounts() {
        if (this.accounts.length) {
          this.accountId = this.accounts[0].accountId;
        }
      },
      _withdrawalError(message) {
        // if (!message) {
        //   return;
        // }

        // this.$Message.error(this.$t(message));

        // this.clearWithdrawal();
      },
      addressId(n, o) {
        this.value = '';
        this.addressTo = '';
        let networkTicker;
        const network = this.addressesList.find(item => item.id === this.addressId);

        if (network) networkTicker = getNetworkName(network.networkId);

        this.getAddressBook({
          route: this.$route,
          router: this.$router,
          page: 1,
          showUrlFilters: false,
          networks: [`${networkTicker}`],
        });

        if (!n) {
          return;
        }

        if (n === o) {
          return;
        }
        if (this.isDebouncing === null) {
          this.isDebouncing = false;
        }
        this.fetchFee();
      },
      // async showCommission(show) {
      //   if (!!show) {
      //     await this.fetchFee()
      //   }
      // }
    },
    computed: {
        ...mapState('app', {
          currencies: state => state.currencies,
          addressWithdrawal: state => state.modal.payload?.addressId,
        }),
        ...mapState('accounts', [
          'accounts',
        ]),
        ...mapState('withdrawalRequestModal', [
          'withdrawal',
        ]),
        ...mapState('addressBook', {
          listAddress: state => state.listCurrenciesAddress,
        }),
        ...mapState('withdrawalRequestModal', {
          _feePending: state => state.fee.pending,
          _feeComplete: state => state.fee.complete,
          _feeCode: state => state.fee.code,
          _feeAmount: state => state.fee.amount,

          _tariffFee: state => state.fee.tariffFee,
          _tariffFeeUSD: state => state.fee.tariffFeeUSD,
          _networkFee: state => state.fee.networkFee,
          _networkFeeUSD: state => state.fee.networkFeeUSD,

          _feeUSD: state => state.fee.usdAmount,
          _feeUntil: state => state.fee.until,
          _feeCurrency: state => state.fee.currency,
          _feeToken: state => state.fee.token,
          _feeSource: state => state.fee.source,

          _withdrawalPending: state => state.withdrawal.pending,
          _withdrawalComplete: state => state.withdrawal.complete,
          _withdrawalError: state => state.withdrawal.error,
          _withdrawalRequestId: state => state.withdrawalRequestId,
          _withdrawalId: state => state.withdrawal.id,
          _withdrawalStatus: state => state.withdrawal.status,
          _withdrawalTX: state => state.withdrawal.tx,
          _withdrawalTraceId: state => state.withdrawal.traceId,
        }),
        ...mapGetters('app', [
          'getCurrencyNameById',
        ]),
        ...mapGetters('balances', [
            'balances',
        ]),
        ...mapGetters('app', [
            'isOpenModal',
        ]),
        filteredAddressesList () {
            return this.listAddress.filter(({networks}) => networks.some(item => item === this.balanceNetworkId))
        },
        withdrawalHash () {
            return this.withdrawal.tx
        },
        withdrawalCreated() {
            return !this._withdrawalPending && this._withdrawalComplete && this._withdrawalRequestId;
        },
        withdrawalCreating() {
            return this._withdrawalPending;
        },
        fetchingFee() {
            return this._feePending;
        },
        fetchedSuccessFee() {
            return !this.fetchingFee && this._feeComplete && this._feeCode === 0;
        },
        fetchedFailFee() {
            return !this.fetchingFee && this._feeComplete && this._feeCode !== 0;
        },

        feeSourceTitle() {
            if (this._feeSource === FEE_TOKEN_SOURCE.ADVANCED_BALANCE) {
                return this.$t('create-withdrawal-request-modal.advance_balance');
            } else if (this._feeSource === FEE_TOKEN_SOURCE.WALLET) {
                return this.$t('create-withdrawal-request-modal.withdrawal_amount');
            }

            return '';
        },
        tariffFee() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._tariffFee);
        },
        tariffFeeUSD() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._tariffFeeUSD);
        },
        networkFee() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._networkFee);
        },
        networkFeeUSD() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._networkFeeUSD);
        },

        feeAmount() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._feeAmount);
        },

        feeUSD() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return this._feeUSD;
        },
        feeCurrency() {
            if (!this.fetchedSuccessFee) {
                return '';
            }

            return this._feeCurrency;
        },
        feeAvailableSeconds() {
            const now = moment(this.time);
            const until = moment(this._feeUntil);

            const delta = until.diff(now, 'seconds');

            if (delta > 0) {
                return delta;
            }

            if (delta <= -1) {
                return -1;
            }

            return 0;
        },

        account() {
            return this.accounts.find(a => a.accountId === this.accountId);
        },
        accountCurrency() {
            return this.currencies.find(c => c.id === this.account?.currencyId);
        },
        accountBalance() {
            return this.account?.balance || '0';
        },

        accountCurrencyId() {
            return this.accountCurrency?.id;
        },

        addressesList() {
            return this.addresses
                .filter(b => !!Number(b.balance))
                .map(b => ({
                    id: b.id,
                    address: b.address,
                    currencyId: b.currencyId,
                    networkId: b.networkId,
                    balance: Number(b.balance),

                    currency: this.getCurrencyNameById(b.currencyId),
                    name: getNetworkSystemName(b.networkId),

                    label: `${preparedString(b.address, 7)} | ${b.balance} ${getCurrencyTicker(b.currencyId)}`,
                }));
        },

        balance() {
            return this.addresses.find(a => a.id === this.addressId);
        },
        balanceCurrency() {
            return this.currencies.find(c => c.id === this.balance?.currencyId);
        },
        balanceAmount() {
            return Number(this.balance?.balance || '0');
        },
        balanceNetwork() {
            return this.balanceCurrency?.networks.find(n => n.id === this.balance.networkId);
        },

        balanceCurrencyId() {
            return this.balanceCurrency?.id;
        },
        balanceNetworkId() {
            return this.balanceNetwork?.id;
        },

        hasTag() {
            return this.balance?.tagRegex;
        },

        balanceValid() {
            if (this._feeSource === FEE_TOKEN_SOURCE.ADVANCED_BALANCE) {
                return new BigNumber(this.accountBalance).gte(this.feeAmount);
            }

            return true;
        },
        addressToValid() {
            if (this.addressId) {
                if (this.balanceCurrency?.currency === "BCH") {
                    return bchaddr.isValidAddress(this.addressTo);
                }
            }

            return this.balanceNetwork && this.balanceNetwork.addressRegex && new RegExp(this.balanceNetwork.addressRegex).test(this.addressTo);
        },
        tagValid() {
            return this.balanceNetwork && this.balanceNetwork.tagRegex && new RegExp(this.balanceNetwork.tagRegex).test(this.tag);
        },
        amountValid() {
            if (new BigNumber(this.balanceAmount).lt(this.balanceNetwork.minWithdrawal)) {
                return false;
            }

            if (new BigNumber(this.amount).lt(this.balanceNetwork.minWithdrawal)) {
                return false;
            }

            if (new BigNumber(this.amount).gt(this.balanceAmount)) {
                return false;
            }

            return true;
        },

        minWithdrawal() {
            return this.balanceNetwork?.minWithdrawal || 0;
        },

        amountToReceive() {
            if (this._feeSource === FEE_TOKEN_SOURCE.WALLET) {
                const amount = new BigNumber(this.amount || '0')
                    .minus(this.networkFee)
                    .dp(8, BigNumber.ROUND_HALF_UP);

                if (amount.lte(0)) {
                    return 0;
                }

                return amount.toNumber();
            }

            return new BigNumber(this.amount || '0')
                .dp(8, BigNumber.ROUND_HALF_UP)
                .toNumber();
        },

        actionButtonDisabled() {
            if (!this.addressId) {
                return true;
            }

            if (this.fetchingFee) {
                return true;
            }

            if (!this.balanceValid) {
                return true;
            }

            if (new BigNumber(this.amountToReceive).lte(0)) {
                return true;
            }

            if (this.feeAvailableSeconds < 4) {
                return true;
            }

            if (!this.addressToValid) {
                return true;
            }

            if (this.tag && !this.tagValid) {
                return true;
            }

            if (!this.amountValid) {
                return true;
            }

            if (this.addresses.find(el => el.id === this.addressId).address === this.addressTo) {
                return true;
            }

            if (this.feeAvailableSeconds === -1) {
                return true;
            }

            return false;
        },
        actionButtonTitle() {
            let title = this.$t('create-withdrawal-request-modal.send');

            if (this.feeAvailableSeconds !== -1 && this.amount !== '' && !this.isDebouncing && this.addressTo.length) {
                title += ` (${this.feeAvailableSeconds}s)`;
            }

            return title;
        },

        isOpen() {
            const {
                $options: {name},
                isOpenModal,
            } = this;

            return isOpenModal(name);
        },
        title() {
            return this.$t(this.isSuccess ? 'create-withdrawal-request-modal.application_created' : 'create-withdrawal-request-modal.creating_application');
        },
        hasErrors() {
            return Boolean(this.errors.length);
        },
        creating_an_application() {
            return this.$t('create-withdrawal-request-modal.creating_an_application');
        },
        select_address() {
            return this.$t('create-withdrawal-request-modal.select_address');
        },
        enter_address() {
            return this.$t('create-withdrawal-request-modal.enter_address');
        },
        enter_tag() {
            return this.$t('create-withdrawal-request-modal.enter_tag');
        },
        enter_amount() {
            return this.$t('create-withdrawal-request-modal.enter_amount');
        },
        showMinWithdrawalTip() {
            return this.minWithdrawal !== 0;
        },
        getCurrencyImageForSelect() {
            if (this.addressId) return this.addresses.find((i) => i.id === this.addressId).currencyId;
            return '';
        },
        depositWithdrawalAddressesMatch() {
            if (this.addresses.find(el => el.id === this.addressId).address === this.addressTo)
                return true;
            return false;
        },
        addressModel: {
          get({ addressId, addressesList = [] }) {
            const addressInfo = addressesList.find(({ id }) => id === addressId)
            return addressInfo ?
            {
              ...addressInfo,
              currency: this.getCurrencyNameById(addressInfo.currencyId),
              name: getNetworkSystemName(addressInfo.networkId)
            } : undefined

            // {
              // "id": "75566287-a998-44ee-b331-6d4905681320",
              // "accountId": "316a59ea-be39-4eaa-9392-6fda708f24d8",
              // "currencyId": "3f2168f6-619e-41c1-b9eb-49f1c864df00",
              // "networkId": "6b976e2c-cf6e-4601-ba7e-f3df5af86af7",
              // "address": "0x55Bc2044887dB193BA3BC068A512916f30c30Efb",
              // "tag": "",
              // "balance": "13294",
              // "alias": "shiba",
              // "comment": "",
              // "isBanned": false,
              // "isActive": null,
              // "isArchived": false,
              // "__typename": "AccountBalance",
              // "label": "0x55Bc2***0Efb | 13 294 SHIB",
              // "name": "BSC", "currency": "SHIB" }
          },
          set(v) {
            this.addressId = v.id
          },
        },
        showCommission({ addressModel, amount }) {
          return addressModel.id && amount
        }
    },
    methods: {
        ...mapActions('app', [
            'closeModal',
            'openModal',
        ]),
        ...mapActions('accounts', [
            'getAllNetworks',
        ]),
        ...mapActions('balances', [
        // 'getAllBalances',
        // 'fetchBalances',
            'getAccountBalancesGrouped',
            'getPrice',
        ]),
        ...mapActions('addressBook', [
            'getAddressBook',
            'networkAddressBook',
            'ChangeAddressBook',
        ]),
        ...mapActions('withdrawalRequests', {
            refreshRequests: 'fetchWithdrawalRequests',
            createWithdrawalRequest: 'createWithdrawalRequest',
            fetchNetworkFee: 'fetchNetworkFee',
            requestWithdrawal: 'requestWithdrawal',
        }),
        ...mapActions('withdrawalRequestModal', {
            clearFee: 'clearFee',
            clearWithdrawal: 'clearWithdrawal',

            _fetchFee: 'fetchFee',
            _createWithdrawal: 'createWithdrawal',
        }),

        mobileText(text) {
            if (window.innerWidth <= 576 && text !== null) {
                return text.length > 6 ? `${text.substr(0, 6)}...` : text;
            }
            return text;
        },

        changeAddress(item) {
            const {openModal} = this;
            openModal({
                name: 'ChangeAddressBook',
                payload: {
                    currentId: item.id,
                    currentIdNetwork: item.networks[0],
                    address: item.addressTo,
                    comment: item.comment,
                    noteText: item.alias,
                },
            });
        },

        handleSelectAddress(value) {
            if (value) {
              this.addressTo = value.address
              this.temporaryValue = cloneDeep(value)
            }
        },
        maxAmount() {
            this.amount = this.balance.balance;
        },
        clearAllData() {
            this.accountId = '';
            this.addressId = '';
            this.addressTo = '';
            this.tag = '';
            this.amount = '';
            this.description = '';

            this.clearFee();
            this.clearWithdrawal();
        },

        handleCancelCreate() {
            const {
                clearAllData,
                closeModal,
            } = this;
            closeModal();
            clearAllData();
            this.clearFee()
            this.clearWithdrawal()
            if (this.withdrawalCreated && this.accountId.length) this.getAccountBalancesGrouped({accountId: this.accountId});

        },


        // selectCurrency(balanceId) {
        //     if (!balanceId) {
        //         return false;
        //     }
        //
        //     this.currencyBalance = this.accountBalances.find(balance => balance.id === balanceId);
        //
        //     this.networkFee = this.currencies.find(el => el.id === this.currencyBalance.currencyId).networks.find(network => network.id === this.currencyBalance.networkId).networkFee;
        //
        //     this.getPrice({
        //         from: `${getCurrencyTicker(this.account.currencyId)}`,
        //         to: `${getCurrencyTicker(this.currencyBalance.currencyId)}`,
        //     });
        //
        //
        // },

        startTimer() {
            if (this.timerId) {
                return;
            }

            this.timerId = setInterval(() => {
                this.time = new Date().toJSON();
            }, 1000);
        },
        stopTimer() {
            clearInterval(this.timerId);

            this.timerId = 0;
        },

        fetchFee: _.debounce(function () {
          if (!(this.addressId && this.accountId && this.amount)) {
            return;
          }

          this._fetchFee({
            accountId: this.accountId,
            addressId: this.addressId,
            amount: this.amount,
          });
        }, 500),
        createWithdrawal() {
            if (this._withdrawalPending) {
                return;
            }

            if (this.actionButtonDisabled) {
                return;
            }

            const payload = {
                accountId: this.accountId,
                addressId: this.addressId,
                address: this.addressTo,
                tag: this.tag || null,
                amount: new BigNumber(this.amount)
                    .toFixed(8, BigNumber.ROUND_HALF_DOWN),
                feeToken: this._feeToken,
                description: this.description,
            };
          this.openModal({
            name: 'TwoFaConfirmation',
            payload
          });
            // this._createWithdrawal(payload);
        },

        setMaxAmount() {
          this.amount = this.balanceAmount.toString();
          this.clearFee();
          this.fetchFee()
        },

        getFeeForTransferInput() {
          this.clearFee();
          this.fetchFee()
        },

        addAddress() {
            const {openModal} = this;

            openModal({
                name: 'NewAddressModal',
            });
        },
    },
    // beforeDestroy() {
    //     this.clearFee()
    //     this.clearWithdrawal()
    // }
};
</script>
<style lang="scss" scoped>
  .subscription-address-withdrawal-modal {
    ::v-deep .main-modal {
      font-family: var(--new-front-font-family);

      .modal-header {
        .title {
          display: flex;
          justify-content: center;

          font-size: $h1;
          font-weight: 500;
          color: var(--new-front-text-primary-bg-modal-primary);
        }
      }

      .body-padding-wrapper {
        display: flex;
        flex-direction: column;
        gap: 20px;
        
        padding: 0 30px;

        max-height: 70vh;
        overflow-y: scroll;

        .complete-info {
          display: flex;
          align-items: center;
          flex-direction: column;

          gap: 20px;

          margin-top: -10px;

          &__title {
            font-size: $h1;
            font-weight: 500;
            color: var(--new-front-text-primary-bg-modal-primary);
          }
          &__row {
            display: flex;
            align-items: center;
            justify-content: center;

            font-size: $h4;
            font-weight: 500;

            gap: 7px;

            margin-bottom: 7px;

            .label {
              color: var(--new-front-text-secondary-bg-secondary);
            }
            .value {
              display: flex;
              flex-wrap: nowrap;
              align-items: center;

              color: var(--new-front-text-primary-bg-modal-primary);
            }
          }
        }
        .complete-title {
          text-align: center;
        }

        .select-address-to {
          display: flex;
          align-items: end;
          gap: 10px;
        }

        .amount-max-input {
          &__bottom-label {
            display: flex;
            align-items: center;
            justify-content: end;

            font-size: $h6;
            gap: 7px;

            margin-top: 10px;

            .label {
              color: var(--new-front-text-secondary-bg-secondary);
            }
            .value {
              color: var(--new-front-text-primary-bg-modal-primary);
            }
          }
        }

        .commission-block {
          display: flex;
          align-items: center;
          justify-content: center;

          min-height: 287px;

          margin-top: -20px;

          .info-container {
            width: 100%;

            &.disabled {
              border-bottom: 1px dashed var(--new-front-border-color-disabled);

              .info-container__row {
                border-top: 1px dashed var(--new-front-border-color-disabled);
                &:first-child {
                  border-top: none;
                }
                .first-line {
                  color: var(--new-front-primary-font-color-disabled);
                  .value {
                    .grey {
                      color: var(--new-front-primary-font-color-disabled);
                    }
                  }
                }
                .second-line {
                  color: var(--new-front-primary-font-color-disabled);
                }
              }
            }

            &__row {
              width: 100%;

              font-size: $h4;

              border-top: 1px dashed var(--border-color);
              &:first-child {
                border-top: none;
              }
              padding: 10px 0;

              .first-line {
                display: flex;
                align-items: center;

                color: var(--new-front-primary-font-color);

                padding: 5px 0;

                .label {
                  width: 100%;
                  text-align: left;
                }
                .value {
                  text-align: right;
                  white-space: nowrap;

                  .grey {
                    color: var(--new-front-secondary-font-color);
                  }
                }
              }
              .second-line {
                display: flex;
                align-items: center;

                color: var(--new-front-secondary-font-color);

                padding: 5px 0;

                .label {
                  width: 100%;
                  text-align: left;
                }
                .value {
                  text-align: right;
                  white-space: nowrap;
                }
              }
            }
          }
        }
      }

      @include below_phone() {
        .modal-header {
          .title {
            font-size: $h3;
          }
        }
        .body-padding-wrapper {
          padding: 0 20px;

          .select-address-to {
            display: flex;
            align-items: end;
            gap: 10px;

            .address-book {
              margin-bottom: -6px;
            }
          }

          .amount-max-input {
            &__bottom-label {
              font-size: $h8;
            }
          }

          .commission-block {
            .info-container {
              margin-top: 10px;

              &__row {
                font-size: $h6;
              }
            }

          }
        }
      }
    }
  }
</style>